import { render } from "./MenuItemIcon.vue?vue&type=template&id=5b93bd43"
import script from "./MenuItemIcon.vue?vue&type=script&lang=js"
export * from "./MenuItemIcon.vue?vue&type=script&lang=js"

import exportComponent from "/Users/saleem/Sites/unitedtours/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__